import Head from 'next/head';
import { useRouter } from 'next/router';

import { favicons } from '@/constants';
// !STARTERCONF Change these default meta
const defaultMeta = {
  title: 'Cashrewards',
  siteName: 'Cashrewards',
  description: `Australia best online cashback offers, deals, vouchers & promo codes from over 1,200 retailers & start saving today. Why wouldn't you?`,
  /** Without additional '/' on the end, e.g. https://theodorusclarence.com */
  type: 'website',
  robots: 'follow, index',
  /** No need to be filled, will be populated with openGraph function */
  image: 'https://cdn.cashrewards.com/images/Cashrewards_Purple.png',
  url: 'https://www.cashrewards.com.au',
};

type SeoProps = {
  date?: string;
  templateTitle?: string;
} & Partial<typeof defaultMeta>;

export default function Seo(props: SeoProps) {
  const router = useRouter();
  const meta = {
    ...defaultMeta,
    ...props,
  };
  meta['title'] = props.templateTitle
    ? `${props.templateTitle} | ${meta.siteName}`
    : meta.title;

  return (
    <Head>
      <title>{meta.title}</title>
      <meta name='robots' content={meta.robots} />
      <meta content={meta.description} name='description' />
      <meta property='og:url' content={`${meta.url}${router.basePath}`} />
      <link rel='canonical' href={`${meta.url}${router.basePath}`} />
      {/* Open Graph */}
      <meta property='og:type' content={meta.type} />
      <meta property='og:site_name' content={meta.siteName} />
      <meta property='og:description' content={meta.description} />
      <meta property='og:title' content={meta.title} />
      <meta name='image' property='og:image' content={meta.image} />
      {/* Twitter */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={meta.title} />
      <meta name='twitter:description' content={meta.description} />
      <meta name='twitter:image' content={meta.image} />

      {/* Favicons */}
      {favicons.map((linkProps) => (
        <link key={linkProps.href} {...linkProps} />
      ))}
      <meta name='theme-color' content='#ffffff' />
    </Head>
  );
}
